import React from "react";
import AdminConfigurator from "./AdminConfigurator";

function AdminPanel() {
  const role = sessionStorage.getItem("role");

  if (role !== "Admin") {
    return <div>Not authorized</div>;
  }

  return (
    <>
      <h2>Admin</h2>
      <AdminConfigurator />
    </>
  );
}

export default AdminPanel;